import React, { Suspense, lazy, useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Button, Card, Form, Input, message } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { API_CONFIG } from '../../config/api';
import AdminLayout from './layout';
import Dashboard from './dashboard';
import UserManagement from './user-management';
import DataAnalysis from './data-analysis';
import AdminTest from './test';
import Settings from './settings';

const TaskManagement = lazy(() => import('./task-management'));
const DeletedTasksPage = lazy(() => import('./DeletedTasks'));

const AdminPage: React.FC = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const login = async ({ username, password }: { username: string; password: string }) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_CONFIG.TASK_MANAGER_BASE}/auth/admin/login`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include', body: JSON.stringify({ username, password }),
      });
      if (!response.ok) throw new Error((await response.json()).detail || '登录失败');
      setAuthenticated(true);
      message.success('管理员登录成功');
    } catch (error) {
      message.error(error instanceof Error ? error.message : '登录失败');
    } finally {
      setLoading(false);
    }
  };

  if (!authenticated) {
    return <Card title="管理员登录" style={{ maxWidth: 420, margin: '120px auto' }}>
      <Form form={form} onFinish={login} initialValues={{ username: 'no-reply@cusabio.com' }}>
        <Form.Item name="username" rules={[{ required: true, type: 'email', message: '请输入管理员邮箱' }]}> 
          <Input prefix={<UserOutlined />} placeholder="管理员邮箱" size="large" />
        </Form.Item>
        <Form.Item name="password" rules={[{ required: true, message: '请输入管理员密码' }]}>
          <Input.Password prefix={<LockOutlined />} placeholder="管理员密码" size="large" />
        </Form.Item>
        <Button type="primary" htmlType="submit" loading={loading} block>登录</Button>
      </Form>
    </Card>;
  }

  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route
          path="/task-management"
          element={
            <Suspense fallback={null}>
              <TaskManagement />
            </Suspense>
          }
        />
        <Route
          path="/deleted-tasks"
          element={
            <Suspense fallback={null}>
              <DeletedTasksPage isAdmin />
            </Suspense>
          }
        />
        <Route path="/users" element={<UserManagement />} />
        <Route path="/data" element={<DataAnalysis />} />
        <Route path="/test" element={<AdminTest />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminPage; 